import React from "react"
import PropTypes from "prop-types"
import { CmsImage } from "@bw/bits"
import { TeaserProfile } from "@bw/partials"
import { grid } from "./ListOfProfiles.module.css"

const ListOfProfiles = ({ profiles }) => {
  if (profiles.length === 0) {
    return null
  }

  return (
    <div className={grid}>
      {profiles.map(profile => {
        return (
          <TeaserProfile
            key={profile.id}
            to={profile.displayOnProfilesListOnly ? null : profile.url}
            name={profile.getFullName()}
            role={profile.role}
            portrait={
              profile.portrait ? (
                <CmsImage src={profile.portrait} alt={profile.portrait.alt} />
              ) : undefined
            }
          />
        )
      })}
    </div>
  )
}

ListOfProfiles.propTypes = {
  profiles: PropTypes.arrayOf(PropTypes.object),
}

ListOfProfiles.defaultProps = {
  profiles: [],
}

export { ListOfProfiles }
